import React from 'react'
import MuiTypography, { TypographyProps } from '@mui/material/Typography'
import { useCustomTranslation } from '../../Hooks/useCustomTranslation'
import { Trans } from 'react-i18next'

interface Props extends TypographyProps {
  values?: { [key: string]: string | number } /* used to hand in values into the translation like 'Hello {{name}}' */
  components?: {
    [tagName: string]: React.ReactElement
  } /* used to hand in components like <span> etc. Supported by default are ['br', 'strong', 'i', 'b', 'u', 'p'] */
  children?: string
}

/**
 * Custom Typography component to automatically allow usage of basic html tags in translated texts.
 * Allowed tags are: <b>, <i>, <u>, <br>, <strong>, <p>
 * @param props - Props like in MUI Typography, but with additional translationKey and values
 */
const Typography: React.FC<Props> = props => {
  const { values, components, children, ...otherProps } = props
  const { t } = useCustomTranslation()

  if (!children) {
    return <MuiTypography {...otherProps} />
  }

  return (
    <MuiTypography {...otherProps} data-qa={`typography-${children}`}>
      <Trans i18nKey={children} t={t} values={values} components={components} />
    </MuiTypography>
  )
}

export default Typography
